import { InternalPayItemConnectionClassType, alphabeticalSort } from 'shared'
import { HelpMessage } from 'utils/constants'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CIMSTags } from 'components/CIMSTags'
import { PayItemConnectionGroup } from '../GroupsContext'
import { CIMSTagsTag } from 'components/CIMSTags/types'

export function useColumns(): CIMSColumn<PayItemConnectionGroup>[] {
  return [
    useNameColumn({
      help: HelpMessage.Name,
      width: 'auto',
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Group'),
    {
      title: 'Connections & Modules',
      render: ({ connections, internalConnections }) => {
        const sorted = [...connections, ...internalConnections].sort(
          alphabeticalSort('order')
        )
        return (
          <CIMSTags
            noSort
            tags={sorted.reduce((items, item) => {
              if (item.__typename === 'PayItemConnection') {
                const { name, googleSheet } = item
                items.push({
                  text:
                    name ??
                    (googleSheet
                      ? googleSheet.title ?? googleSheet.compositeId
                      : 'Unknown'),
                  tooltip: googleSheet ? 'Google Sheet' : undefined,
                })
              } else if (item.__typename === 'ProjectToInternalConnection') {
                const { module } =
                  InternalPayItemConnectionClassType.fromIdOrFail(
                    item.internalConnectionId
                  )
                items.push({ text: module.name, color: 'blue' })
              }
              return items
            }, Array<CIMSTagsTag>())}
            direction={{ tags: 'vertical' }}
          />
        )
      },
      help: HelpMessage.PayItems.Manage.Groups.Connections,
      filter: {
        type: 'search',
        with: 'callback',
        onFilter: (value, { connections, internalConnections }) => {
          const lower = value.toString().toLowerCase()
          const byConnection = connections.some(({ name, googleSheet }) =>
            (name ?? googleSheet?.title)?.toLowerCase().includes(lower)
          )
          const byInternal = internalConnections.some(
            ({ internalConnectionId }) =>
              InternalPayItemConnectionClassType.fromIdOrFail(
                internalConnectionId
              )
                .module.name.toLowerCase()
                .includes(lower)
          )
          return byConnection || byInternal
        },
      },
    },
  ]
}
